import React, { useEffect } from "react";
import CustomTable from "../../../../components/Tables/CustomTable";
import { useAppDispatch, useAppSelector } from "../../../../redux/app/hooks";
import {
  fetchUsersAsync,
  resetAdminState,
  setSelectedUser,
} from "../../../../redux/features/adminSlice";
import WhiteTitledCard from "../../../../components/cards/WhiteTitledCard";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import ExportUsersCsvButton from "../components/ExportUsersCsvButton";
import { useUserFilters } from "../useUserFilters";
import UserFilterBar from "../UserFilterBar";
import {
  formatUserAmount,
  formatUserCount,
  getUserOrderCount,
} from "../userMetrics";

const BuyerTable: React.FC = () => {
  const { buyers, isLoading } = useAppSelector((state) => state.admin);
  const filters = useUserFilters("BUYER");
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const columns = [
    { label: "S/N", field: "id" },
    { label: "Name of Buyer", field: "buyer_name" },
    { label: "Username", field: "username" },
    { label: "Phone Number", field: "phone_number" },
    { label: "Email", field: "email" },
    { label: "Country", field: "country" },
    { label: "Order Amount", field: "order_amount" },
    { label: "Order Count", field: "order_count" },
    { label: "Reg. Date", field: "date_added" },
  ];

  const buyersData = buyers?.data?.data?.map((buyer: any, index: number) => {
    return {
      _buyer: buyer,
      id: index + 1,
      buyer_name: buyer?.fullName ?? "N/A",
      username: buyer?.username ?? "N/A",
      phone_number: buyer?.phoneNumber ?? "N/A",
      country:
        (typeof buyer?.country === "string"
          ? buyer?.country
          : buyer?.country?.name) ?? "N/A",
      order_amount: formatUserAmount(buyer),
      order_count: formatUserCount(getUserOrderCount(buyer)),
      email: buyer?.email ?? "N/A",
      date_added: moment(buyer?.createdAt).format("MMM DD, YYYY"),
    };
  });

  useEffect(() => {
    dispatch(resetAdminState());
    dispatch(fetchUsersAsync(filters.listParams));
  }, [dispatch, filters.listParams]);

  const tabList = [
    { id: 1, name: "All Buyers", count: buyers?.data?.totalItems ?? 0 },
  ];

  return (
    <WhiteTitledCard>
      <div className="px-4">
        <UserFilterBar
          filters={filters}
          userType="BUYER"
          panelId="buyer-filter-panel"
          searchPlaceholder="Search buyer name, email, username"
          actions={
            <ExportUsersCsvButton
              totalItems={buyers?.data?.totalItems ?? 0}
              params={filters.exportParams}
            />
          }
        />

        <div className="flex flex-col md:flex-row flex-wrap items-center gap-3 mb-4">
          {tabList?.map((tab) => (
            <div
              key={tab.id}
              className="space-x-2 cursor-pointer text-sm font-semibold p-2 text-black border-b-2 border-primary"
            >
              <span>{tab.name}</span>
              <span className="bg-lightPurple px-2 text-accent rounded-md">
                {tab?.count}
              </span>
            </div>
          ))}
        </div>

        <CustomTable
          data={{ columns, rows: buyersData }}
          onRowClick={(row) => {
            dispatch(setSelectedUser(row._buyer));
            navigate(`/user-management/buyer/${row._buyer?.id}`);
          }}
          noRecordText="No buyer Users Available"
          loading={isLoading}
          showFooter={true}
          totalPages={buyers?.data?.totalPages}
          itemsPerPage={buyers?.data?.itemsPerPage}
          currentPage={filters.page}
          onPageChange={(value: number) => filters.setPage(value)}
          onLimitChange={(value: number) => {
            filters.setLimit(value);
            filters.setPage(0);
          }}
        />
      </div>
    </WhiteTitledCard>
  );
};

export default BuyerTable;
